import React, { useEffect, useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Button } from "@mui/material";

const API_URL =
  "https://stageapi.stage.in/v20/subscription/getUserSubscriptionStatus";
const MAX_POLLING_TIME = 30000; // 30 seconds
const POLLING_INTERVAL = 3000; // 3 seconds

const Pending = ({ authToken }) => {
  const [polling, setPolling] = useState(false);
  const [success, setSuccess] = useState(false);

  const fetchSubscriptionStatus = async (intervalId) => {
    try {
      const response = await axios.get(API_URL, {
        params: {
          lang: "hin",
          dialect: "har",
          deviceId: "ls0bxn5n",
          isRenew: false,
          os: "macOS",
          platform: "web",
          isRecurringSubscriptionBuild: true,
          isTrialSubscriptionBuildUser: true,
          appId: "in.stage",
        },
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      console.log();

      if (response?.data?.data?.subscriptionStatus === 1) {
        toast.success("Subscription has been activated!");
        setSuccess(true);
        setPolling(false);
        clearInterval(intervalId);
        //   window.location.href = "/pay";
      }
      // Check if the response indicates success
      if (response.data && response.data.success) {
        toast.success("Subscription status fetched successfully!");
        setPolling(false);

        // Fire any success event or handle success case here
      }
    } catch (error) {
      toast.error("Failed to fetch subscription status.");
      console.error("Error fetching subscription status:", error);
    }
  };

  useEffect(() => {
    let intervalId;
    const startTime = Date.now();

    setPolling(true);
    intervalId = setInterval(() => {
      const elapsedTime = Date.now() - startTime;
      if (elapsedTime >= MAX_POLLING_TIME) {
        setPolling(false);
        clearInterval(intervalId);
        toast.info("Max polling time reached. Stopping polling.");
      } else {
        fetchSubscriptionStatus(intervalId);
        // else {
        //   clearInterval(intervalId);
        //   toast.info("Polling stopped.");
        // }
      }
    }, POLLING_INTERVAL);

    return () => {
      clearInterval(intervalId);
      setPolling(false);
    };
  }, [authToken]);

  if (success) {
    toast.success("Subscription has been activated!");

    const isTrialStarted = localStorage.getItem("trialStarted");

    if (typeof window.sendFbEvent === "function" && !isTrialStarted) {
      window.sendFbEvent("track", "StartTrial", {
        value: "1.00",
        currency: "INR",
      });
      localStorage.setItem("trialStarted", true);
      setPolling(false);
    }
    // setTimeout(() => {
    //   window.location.href = "https://download.stage.in";
    //   return null; // Return null or a loader while the redirection is in progress
    // }, 2000);
  }

  return (
    <div>
      <ToastContainer />
      {polling ? (
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <p>Checking subscription status...</p>
          {/* Implement a better UI for the pending state here */}
          {/* Example: a spinning loader */}
          <div className="loader"></div>
        </div>
      ) : success ? (
        // Redirect or indicate success more clearly
        <>
          <img
            src="https://media.stage.in/static/successfull.webp"
            alt="success"
            style={{
              width: "80%",
              height: "auto",
              margin: "auto",
              display: "block",
            }}
          />
          <p>आपका ₹ 1 का ट्रायल शुरू हो गया है</p>

          <Button
            variant="contained"
            style={{
              background: "#2ABC4B",
              width: "70vw",
              maxWidth: "400px",
              borderRadius: "2rem",
            }}
            href="https://play.google.com/store/apps/details?id=in.stage&"
          >
            <img
              src="https://media.stage.in/static/playstore.png"
              alt="success"
              style={{
                width: "40%",
                height: "auto",
                margin: "auto",
                display: "block",
              }}
            />
            यहाँ से STAGE App डाउनलोड करें
          </Button>
          {/* <button
          style={{ background: "#2ABC4B", color: "#fffff0" }}
          href="https://download.stage.in"
        >
          यहाँ से STAGE App डाउनलोड करें और देखना शुरू करें
        </button> */}
        </>
      ) : (
        <p>Not polling</p>
      )}
    </div>
  );
};

export default Pending;
